import { useToast } from "@chakra-ui/react";
import { useState } from "react";
import { NavigateFunction } from "react-router-dom";
import { CurrentActiveUserInterface } from "../constants/User";
import { axiosBuyer, axiosReseller } from "../utils/AxiosInstance";
import { getAxiosInstance } from "../utils/helperFunction";

// Favorite Product Status to  check if product is favorite or not
export const checkFavoriteStatus = async (productId: number) => {
  if (!productId) return false;

  const url = `${process.env.REACT_APP_WEB_API_BASE_URL}/v1/buyer/favorite`;

  try {
    const response = await axiosBuyer.get(url);
    const favoriteProducts = response?.data?.data || [];

    return favoriteProducts?.some(
      (favorite: any) => favorite?.product?.id === productId
    );
  } catch (error) {
    return false;
  }
};

// Handle toggle favorite to add or remove product from favorite list
export const useFavorite = (
  toast: (options: any) => void,
  isFavorite: boolean,
  setIsFavorite: (value: boolean) => void
) => {
  const [isAddingToFavoriteLoading, setIsAddingToFavoriteLoading] =
    useState<boolean>(false);

  const toggleFavorite = async (
    resellerId: number,
    productId: number,
    variantId: number
  ) => {
    setIsAddingToFavoriteLoading(true);
    const url = `${process.env.REACT_APP_WEB_API_BASE_URL}/v1/buyer/favorite`;
    const payload = {
      store_id: resellerId,
      product_id: productId,
      variant_id: variantId,
    };

    // realtime new favorite value
    const newIsFavorite = !isFavorite;

    try {
      await axiosBuyer.post(url, payload);
      setIsFavorite(newIsFavorite);
      toast({
        title: `Produk berhasil ${
          newIsFavorite ? "ditambahkan ke" : "dihapus dari"
        } favorit.`,
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error: any) {
      toast({
        title: error?.response?.data?.message || "Terjadi kesalahan.",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } finally {
      setIsAddingToFavoriteLoading(false);
    }
  };

  return {
    isAddingToFavoriteLoading,
    toggleFavorite,
  };
};

export const useAddProduct = () => {
  const [isFetchLoading, setIsFetchLoading] = useState<boolean>(false);
  const nativeToast = useToast();

  const addProduct = async (id: string) => {
    const fetchApi = async () => {
      const response = await axiosReseller.put(`/v1/reseller/product/${id}`, {
        added: 1,
      });
      return response.data;
    };

    try {
      setIsFetchLoading(true);

      const response = await fetchApi();

      nativeToast({
        title: "Produk berhasil ditambahkan ke store",
        description: response.message || "Produk berhasil ditambahkan.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (err: any) {
      // Memastikan error memiliki data.message
      const errorMessage =
        err?.response?.data?.message ||
        "Terjadi kesalahan, coba lagi beberapa saat.";

      nativeToast({
        title: "Gagal menambahkan produk",
        description: errorMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsFetchLoading(false);
    }
  };

  return { isFetchLoading, addProduct };
};

export const goToDashboardFromNotif = (
  id: any,
  link: string,
  isRead: number,
  navigate: NavigateFunction,
  currentActiveUser: CurrentActiveUserInterface | null,
  toast: any,
  onRefresh: () => void
) => {
  const payload = {
    id: id,
  };

  let pageType = 1;
  if (currentActiveUser) {
    if (currentActiveUser.role === "reseller") {
      pageType = 2;
    } else if (currentActiveUser.role === "supplier") {
      pageType = 3;
    }
    const axiosInstance = getAxiosInstance(pageType);

    if (isRead === 0) {
      axiosInstance
        .post(`/v1/${currentActiveUser.role}/read-notif`, payload)
        .then((res) => {
          onRefresh();
          link ? navigate(`${link}`) : navigate(`/${currentActiveUser.role}`);
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {});
    } else {
      link ? navigate(`${link}`) : navigate(`/${currentActiveUser.role}`);
    }
  }
};
